import { render, staticRenderFns } from "./TableForm.vue?vue&type=template&id=3a81f046&scoped=true&"
import script from "./TableForm.vue?vue&type=script&lang=js&"
export * from "./TableForm.vue?vue&type=script&lang=js&"
import style0 from "./TableForm.vue?vue&type=style&index=0&id=3a81f046&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a81f046",
  null
  
)

export default component.exports